import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import ContentPageMeta from './ContentPageMeta';
import Footer from './Footer';
import * as FiIcons from 'react-icons/fi';

const { FiHome } = FiIcons;

const Layout = ({ children }) => {
  const { isDark } = useTheme();
  const { t, language, changeLanguage } = useLanguage();

  const handleLanguageToggle = () => {
    changeLanguage(language === 'zh' ? 'en' : 'zh');
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const background = isDark
    ? 'radial-gradient(circle at 20% 90%,rgba(93,92,222,0.2) 0%,transparent 30%),radial-gradient(circle at 90% 10%,rgba(97,218,251,0.2) 0%,transparent 30%),radial-gradient(circle at 60% 40%,rgba(255,222,89,0.15) 0%,transparent 40%),#0f0f23'
    : 'radial-gradient(circle at 20% 90%,rgba(93,92,222,0.15) 0%,transparent 30%),radial-gradient(circle at 90% 10%,rgba(94,23,235,0.15) 0%,transparent 30%),radial-gradient(circle at 60% 40%,rgba(255,222,89,0.1) 0%,transparent 40%),#FFFFFF';

  return (
    <div className="min-h-screen relative" style={{ background }}>
      <div className="app-background">
        {isDark ? (
          <>
            <div className="dark-stars"></div>
            <div className="meteors"></div>
          </>
        ) : (
          <div className="light-stars"></div>
        )}
      </div>

      <div className="container mx-auto px-4 py-6 max-w-6xl relative z-10">
        <div className="flex justify-between items-center mb-8">
          <Link
            to="/"
            onClick={scrollToTop}
            className="text-3xl font-bold flex items-center"
            style={{
              background: 'linear-gradient(90deg,#5D5CDE,#FF8E8E)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            <SafeIcon icon={FiHome} className="mr-2" />
            Beat Buddy
          </Link>

          <div className="flex items-center space-x-4">
            <button
              onClick={handleLanguageToggle}
              className="px-4 py-2 rounded-lg bg-white dark:bg-gray-800 shadow-md hover:shadow-lg transition-all duration-200 text-gray-700 dark:text-gray-300"
            >
              {language === 'zh' ? 'English' : '中文'}
            </button>
            <Link
              to="/"
              onClick={scrollToTop}
              className="px-4 py-2 rounded-lg bg-white dark:bg-gray-800 shadow-md hover:shadow-lg transition-all duration-200 text-gray-700 dark:text-gray-300"
            >
              {t('backToHome')}
            </Link>
          </div>
        </div>

        <main className="mt-8">
          <ContentPageMeta />
          {children}
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default Layout;